import React, { useState, useEffect } from "react";
import "./Cart.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const Cart = ({ onBack, onCheckout, onGoToWishlist, onLoginClick }) => {
  const [cart, setCart] = useState({ items: [] });
  const [loading, setLoading] = useState(true);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  useEffect(() => {
    if (user) {
      fetchCart();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchCart = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setCart(data);
    } catch (err) {
      console.error("Fetch cart error:", err);
    } finally {
      setLoading(false);
    }
  };

  const removeItem = async (itemId) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/cart/remove`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ itemId }),
      });
      if (res.ok) {
        const updatedCart = await res.json();
        setCart(updatedCart);
      }
    } catch (err) {
      console.error("Remove item error:", err);
    }
  };

  const calculateTotal = () => {
    const totalMRP = cart.items.reduce(
      (acc, item) =>
        acc +
        (item.product.originalPrice || item.product.price) * item.quantity,
      0,
    );
    const totalDiscount = cart.items.reduce(
      (acc, item) =>
        acc +
        ((item.product.originalPrice || item.product.price) -
          item.product.price) *
          item.quantity,
      0,
    );
    const totalAmount = totalMRP - totalDiscount;
    return { totalMRP, totalDiscount, totalAmount };
  };

  const { totalMRP, totalDiscount, totalAmount } = calculateTotal();

  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleMockPayment = async () => {
    setIsProcessing(true);

    // Simulate network delay
    setTimeout(async () => {
      try {
        const token = localStorage.getItem("token");

        // 1. Create order in database
        const orderItems = cart.items.map((item) => ({
          product: item.product._id,
          name: item.product.name,
          quantity: item.quantity,
          image: item.product.images[0],
          price: item.product.price,
          size: item.size,
        }));

        const orderRes = await fetch(`${API_BASE_URL}/api/orders`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            orderItems,
            shippingAddress: {
              address: "123 Myntra Street",
              city: "Bangalore",
              postalCode: "560001",
              country: "India",
            },
            totalPrice: totalAmount,
          }),
        });

        if (!orderRes.ok) throw new Error("Order creation failed");

        // 2. Clear cart
        const res = await fetch(`${API_BASE_URL}/api/cart`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.ok) {
          setIsProcessing(false);
          setIsSuccess(true);
          // Wait 2 seconds then go back to home or refresh
          setTimeout(() => {
            onCheckout(); // Redirect to orders page
          }, 2000);
        } else {
          setIsProcessing(false);
          alert("Failed to process order on server.");
        }
      } catch (err) {
        setIsProcessing(false);
        console.error("Mock payment error:", err);
        alert("Payment simulation failed.");
      }
    }, 2000);
  };

  if (isProcessing)
    return (
      <div className="payment-overlay">
        <div className="spinner"></div>
        <h2>Processing Your Payment...</h2>
        <p>Please do not refresh or close the window</p>
      </div>
    );

  if (isSuccess)
    return (
      <div className="payment-overlay">
        <div className="success-modal">
          <div className="success-icon">✓</div>
          <h2>Payment Successful!</h2>
          <p>Your order has been placed. Redirecting...</p>
        </div>
      </div>
    );

  if (loading)
    return (
      <div className="cart-empty container">
        <h2>Loading Bag...</h2>
      </div>
    );

  if (!user)
    return (
      <div className="cart-empty container">
        <h2>Please login to view your bag</h2>
        <button
          className="shop-now-btn"
          style={{ marginTop: "20px" }}
          onClick={onLoginClick}
        >
          LOGIN NOW
        </button>
      </div>
    );

  if (cart.items.length === 0)
    return (
      <div className="cart-empty container">
        <div className="empty-cart-content">
          <img
            src="/below2000.png"
            alt="Empty Bag"
            className="empty-cart-logo"
          />
          <h2>Hey, it feels so light!</h2>
          <p>There is nothing in your bag. Let's add some items.</p>
          <button className="shop-now-btn" onClick={onGoToWishlist}>
            ADD ITEMS FROM WISHLIST
          </button>
        </div>
      </div>
    );

  return (
    <div className="cart-page container">
      <div className="cart-layout">
        {/* Left: Cart Items */}
        <div className="cart-items-section">
          <div className="cart-header-row">
            <h3>Check Delivery Services</h3>
            <button className="address-btn">ENTER PIN CODE</button>
          </div>

          <div className="cart-offers">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
              <line x1="7" y1="7" x2="7.01" y2="7"></line>
            </svg>
            <span>
              Available Offers: 10% Instant Discount on HDFC Bank Cards.
            </span>
          </div>

          <div className="items-list">
            {cart.items.map((item) => (
              <div key={item._id} className="cart-item-card">
                <div className="item-image">
                  <img
                    src={
                      item.product.images?.[0]?.startsWith("http")
                        ? item.product.images[0]
                        : `${API_BASE_URL}${item.product.images?.[0]}`
                    }
                    alt={item.product.name}
                  />
                </div>
                <div className="item-info">
                  <div className="item-header">
                    <h4 className="item-brand">{item.product.brand}</h4>
                    <p className="item-name">{item.product.name}</p>
                  </div>
                  <div className="item-selection">
                    <div className="select-box">
                      Size: <span>{item.size}</span>
                    </div>
                    <div className="select-box">
                      Qty: <span>{item.quantity}</span>
                    </div>
                  </div>
                  <div className="item-price">
                    <span className="curr-price">₹{item.product.price}</span>
                    {item.product.originalPrice > item.product.price && (
                      <>
                        <span className="old-price">
                          ₹{item.product.originalPrice}
                        </span>
                        <span className="item-discount">
                          {Math.round(
                            ((item.product.originalPrice - item.product.price) /
                              item.product.originalPrice) *
                              100,
                          )}
                          % OFF
                        </span>
                      </>
                    )}
                  </div>
                  <div className="return-policy">
                    <strong>14 days</strong> return available
                  </div>
                </div>
                <button
                  className="remove-item-btn"
                  onClick={() => removeItem(item._id)}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Price Details */}
        <div className="price-details-section">
          <h4 className="section-small-title">
            PRICE DETAILS ({cart.items.length} Items)
          </h4>
          <div className="price-grid">
            <div className="price-row">
              <span>Total MRP</span>
              <span>₹{totalMRP}</span>
            </div>
            <div className="price-row">
              <span>Discount on MRP</span>
              <span className="green-text">-₹{totalDiscount}</span>
            </div>
            <div className="price-row">
              <span>Coupon Discount</span>
              <span className="red-text">Apply Coupon</span>
            </div>
            <div className="price-row">
              <span>Platform Fee</span>
              <span className="green-text">FREE</span>
            </div>
            <div className="price-row">
              <span>Shipping Fee</span>
              <span className="green-text">FREE</span>
            </div>
            <div className="price-total">
              <span>Total Amount</span>
              <span>₹{totalAmount}</span>
            </div>
          </div>
          <button className="place-order-btn" onClick={handleMockPayment}>
            PLACE ORDER
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
